import { useEffect, useRef } from "react";

const STORAGE_KEY = "gandpconstruction_newsletter_dismissed";
const POPUP_DELAY = 10000; // 10 seconds

export const useNewsletterPopup = (
  isOpen: boolean,
  openModal: () => void,
  closeModal: () => void
) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Only run on client-side
    if (typeof window === "undefined") return;

    // Check if user has previously dismissed the modal
    const isDismissed = localStorage.getItem(STORAGE_KEY) === "true";

    if (!isDismissed && !isOpen) {
      // Set timer for auto-popup
      timerRef.current = setTimeout(() => {
        openModal();
      }, POPUP_DELAY);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []); // Run once on mount

  const handleDismiss = () => {
    // Store dismissal in localStorage
    localStorage.setItem(STORAGE_KEY, "true");
    closeModal();
  };

  return { handleDismiss };
};

export default useNewsletterPopup;
